import { ThunkDispatch } from 'redux-thunk';

import { CommonAPI } from 'api';
import * as actionTypes from 'shared/store/action-types';
import { createAction } from 'shared/util/utility';

export const fetchCategoriesFlag = () => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		try {
			const categoriesResponse = await CommonAPI.Market.getCategoriesFlag();
			if (categoriesResponse.data.isError === false) {
				dispatch(
					createAction(actionTypes.FETCH_CATEGORIES_FLAGS, {
						categoriesFlags: categoriesResponse.data.data?.flags,
					}),
				);
			}
		} catch (err) {
			console.error(err);

			dispatch(
				createAction(actionTypes.LAYOUT_ERROR_PLACEHOLDER, {
					errorPlaceholder: true,
				}),
			);
		}
	};
};
